// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modals__Modal___3IXys","ModalDetailsPayment_modalDialog":"Modals__ModalDetailsPayment_modalDialog___ONDI9","ModalVoucher__divListVouchers":"Modals__ModalVoucher__divListVouchers___3CXVp"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/treasury/payment-partners/components/Modals.css
// module id = 1004
// module chunks = 0